<template>
  <div class="bg-gray-100">
    <footer class="max-w-6xl py-8 mx-auto sm:py-12">
      <div class="px-5">
        <div class="flex flex-wrap sm:flex sm:flex-wrap sm:-mx-4 md:py-4">
          <div class="w-2/4 px-5 md:w-1/4">
            <h3 class="mb-4 text-lg font-bold">Sitemap</h3>
            <ul class="list-none footer-links">
              <li v-for="sitemap in sitemaps" :key="sitemap.name" class="mb-2">
                <router-link
                  @click.native="scrollToTop"
                  :to="sitemap.route"
                  class="transition-colors duration-300 border-b border-transparent border-solid hover:border-green-600 hover:text-primary-green"
                  >{{ $t(`nav.${sitemap.name}`) }}</router-link
                >
              </li>
            </ul>
          </div>
          <div
            class="w-2/4 px-3 md:w-1/4"
            v-for="item in footer"
            :key="item.id"
          >
            <h3 class="mb-4 text-lg font-bold">Contact us</h3>
            <div>
              <h4
                class="text-xs font-bold tracking-widest text-gray-900 title-font"
              >
                {{ $t("physical-address") }}
              </h4>
              <p class="mt-1 text-sm leading-relaxed">
                <VueShowdown :markdown="item.PhysicalAddress" />
              </p>
            </div>
            <div>
              <h2
                class="mt-4 text-xs font-bold tracking-widest text-gray-900 title-font"
              >
                {{ $t("email") }}
              </h2>
              <a
                href="mailto:info@samaritansc.com"
                class="leading-relaxed text-primary-orange"
              >
                <VueShowdown :markdown="item.Email" />
              </a>
              <h2 class="mt-4 text-xs font-bold tracking-widest text-gray-900">
                {{ $t("phone") }}
              </h2>
              <p class="text-sm leading-relaxed">
                <VueShowdown :markdown="item.Phone" />
              </p>
            </div>
          </div>
          <div class="w-1/2 px-5 mt-10 md:mt-0 md:w-1/4 md:text-center">
            <h3 class="mb-4 text-lg font-bold">Terms and Policies</h3>
            <ul class="list-none footer-links">
              <li class="mb-2">
                <router-link
                  @click.native="scrollToTop"
                  to="/imprint"
                  class="transition-colors duration-300 border-b border-transparent border-solid hover:border-green-600 hover:text-primary-green"
                  >Imprint</router-link
                >
              </li>
              <li class="mb-2">
                <router-link
                  @click.native="scrollToTop"
                  to="/privacy-policy"
                  class="transition-colors duration-300 border-b border-transparent border-solid hover:border-green-600 hover:text-primary-green"
                  >Privacy policy</router-link
                >
              </li>
            </ul>
          </div>
          <div class="w-1/2 px-5 mt-10 md:mt-0 md:w-1/4 md:text-right">
            <h3 class="mb-4 text-lg font-bold">Stay connected</h3>
            <div class="flex flex-wrap space-x-3 md:space-x-6 md:justify-end">
              <a
                v-for="item in social"
                :key="item.id"
                :href="item.Url"
                target="_blank"
                class="px-1 py-1 rounded-full outline-none bg-gray-50 hover:bg-gray-200 focus:outline-none"
              >
                <img
                  :src="getBaseUrl() + item.Image.url"
                  :alt="item.Url"
                  class="w-6 h-6"
                />
              </a>
            </div>
          </div>
        </div>
        <div
          class="pt-6 mt-6 border-t sm:flex sm:flex-wrap sm:-mx-4 sm:mt-12 sm:pt-12"
        >
          <div class="w-full px-4 text-sm text-center">
            <p>
              &copy;{{ new Date().getFullYear() }}
              {{ $t("samaritan-surgical-center") }}
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from "axios";
import { baseUrl } from "../../Api";
import { mapGetters } from "vuex";

export default {
  name: "Footer",
  data: () => ({
    footer: [],
    social: [],
    imprint: "",
    privacy: "",
    sitemaps: [
      {
        name: "home",
        route: "/",
      },
      {
        name: "services",
        route: "/departments",
      },
      {
        name: "doctors",
        route: "/doctors",
      },
      {
        name: "news",
        route: "/news",
      },
      {
        name: "about-us",
        route: "/about-us",
      },
      {
        name: "contact-us",
        route: "/contact-us",
      },
      {
        name: "reviews",
        route: "/reviews",
      },
    ],
  }),

  computed: {
    ...mapGetters({
      lang: "LanguageStore/lang",
      apiFooter: "LanguageStore/apiFooters",
      // apiSocial: "LanguageStore/apiSocials",
      // apiImprint: "LanguageStore/apiImprints",
      // apiPrivacy: "LanguageStore/apiPrivacies",
    }),
  },
  watch: {
    async lang() {
      this.loading = true;
      await this.getData();
    },
  },
  methods: {
    scrollToTop() {
      this.open = !this.open;
      window.scrollTo(0, 0);
    },
    getBaseUrl() {
      return baseUrl;
    },
    async getData() {
      try {
        const social = await axios.get(`${baseUrl}/socials`);
        this.social = social.data;

        const imprint = await axios.get(`${baseUrl}/Imprints`);
        this.imprint = imprint.data;

        const footer = await axios.get(this.apiFooter);
        this.footer = footer.data;

        const privacy = await axios.get(`${baseUrl}/privacies`);
        this.privacy = privacy.data;

        this.loading = false;
      } catch (error) {
        this.error = error;
      }
    },
  },
  async created() {
    await this.getData();
  },
};
</script>

<style></style>
